
import {
  getStopReasonPage,
  getStopReasonDel,
  updataStopReason
} from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import addStopReason from "./components/add-stop-reason.vue";
import updataStopReasonPage from "./components/updata-stop-reason.vue";
import allConfigReason from "./components/all-config-reason.vue";
import { getOptionList, optionKey } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-stop-reason": addStopReason,
    "pi-updata-stop-reason": updataStopReasonPage,
    "pi-all-config-reason": allConfigReason
  }
})
export default class PiSIMManage extends Vue {
  private formInline: objAny = {
    entSubUser: true,
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    logined: true
  };
  private responsibilityTypeList: object[] = [];
  private privilegeVoObj: objAny = {};
  private fileStatusColor: objAny = {
    "1": "primary",
    "2": "default",
    "3": ""
  };
  private loading = false;
  private total = 0;

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("stopReason.stopCode"),
      key: "stopCode",
      minWidth: 120
    },
    {
      title: i18n.t("stopReason.stopName"),
      key: "stopName",
      minWidth: 100
    },
    {
      title: i18n.t("stopReason.duty"),
      key: "duty",
      minWidth: 160,
      slot: "duty"
    },
    {
      title: i18n.t("operation"),
      key: "action",
      width: 120,
      slot: "action"
    }
  ];
  public qyeryClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getStopReasonPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      ret.data.map((item: objAny) => {
        item.responsibilityType = item.responsibilityType + "";
      });
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public addClick(): void {
    const addStopReason: objAny = this.$refs["addStopReason"];
    addStopReason.open();
  }

  public editClick(item: objAny) {
    const updataStopReasonPage: objAny = this.$refs["updataStopReasonPage"];
    updataStopReasonPage.open(item);
  }
  public allConfig() {
    const allConfigReason: objAny = this.$refs["allConfigReason"];
    allConfigReason.open();
  }
  async delItemClick(item: objAny): Promise<void> {
    const ret = await getStopReasonDel({
      stopCode: item.stopCode
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  async getOptionList() {
    const ret = await getOptionList([optionKey.responsibilityTypeObj]); //请求字典
    this.responsibilityTypeList = ret[optionKey.responsibilityTypeObj];
  }
  async updataStopReason(item: objAny) {
    if (item.responsibilityType) {
      const ret = await updataStopReason({
        responsibilityType: item.responsibilityType,
        stopCode: item.stopCode,
        stopName: item.stopName
      });
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("updateSuccess"));
        this.getTableList();
      }
    }
  }

  mounted() {
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
    this.getTableList();
    this.getOptionList();
  }
}
